import React from 'react';
import { Microscope, Hammer, FileCheck, Users } from 'lucide-react';

const Institute = () => {
    return (
        <section id="i3" className="py-24 bg-surface text-center">
            <div className="container mx-auto px-6">
                <div className="mb-16">
                    <span className="text-primary font-mono text-sm tracking-widest uppercase mb-4 block">EL VEHÍCULO</span>
                    <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">Instituto de Innovación Iztacalco (i³)</h2>
                    <p className="max-w-3xl mx-auto text-text-muted text-lg leading-relaxed">
                        Operamos como un laboratorio de políticas públicas. Utilizamos Ciencia de Datos, Blockchain e IoT para diagnosticar fallos sistémicos.
                        <strong className="text-white ml-2">No somos un partido</strong>; somos la respuesta técnica a la ineficiencia.
                    </p>
                </div>

                {/* Functions Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="p-6 border border-zinc-800 rounded-xl bg-background hover:-translate-y-1 transition-transform">
                        <Microscope className="w-8 h-8 text-primary mx-auto mb-4" />
                        <h4 className="font-bold text-white mb-2">Investigación</h4>
                        <p className="text-sm text-zinc-500">Estudios open source de movilidad, agua y seguridad.</p>
                    </div>
                    <div className="p-6 border border-zinc-800 rounded-xl bg-background hover:-translate-y-1 transition-transform">
                        <Hammer className="w-8 h-8 text-primary mx-auto mb-4" />
                        <h4 className="font-bold text-white mb-2">Acción Directa</h4>
                        <p className="text-sm text-zinc-500">Brigadas de reparación e instalación de sensores.</p>
                    </div>
                    <div className="p-6 border border-zinc-800 rounded-xl bg-background hover:-translate-y-1 transition-transform">
                        <FileCheck className="w-8 h-8 text-primary mx-auto mb-4" />
                        <h4 className="font-bold text-white mb-2">Transparencia</h4>
                        <p className="text-sm text-zinc-500">Auditoría forense de corrupción con datos duros.</p>
                    </div>
                    <div className="p-6 border border-zinc-800 rounded-xl bg-background hover:-translate-y-1 transition-transform">
                        <Users className="w-8 h-8 text-primary mx-auto mb-4" />
                        <h4 className="font-bold text-white mb-2">Formación</h4>
                        <p className="text-sm text-zinc-500">Capacitación de estudiantes en gobernanza basada en evidencia.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Institute;

